<template>
  <Sheet class="p-4 " height="30%">
    <div class="flex flex-col justify-center mt-4 ">
      <div
        href="https://api.whatsapp.com/send?phone=9013432121"
        class="flex flex-row justify-start cursor-pointer w-full border bg-HomeBack border-gray-400 p-4 shadow-md rounded-md"
      >
        <font-awesome-icon icon="phone-flip"  class="text-ColorNerkh"/>
        <p class="text-sm  text-white mx-2"> رزرو تالار
          : </p>
        <p class="text-base font-bold  text-white">09013432121</p>
      </div>
      <div
        href="https://www.instagram.com/takhtejamshidshandiz/"
        class="flex flex-row justify-start cursor-pointer w-full border bg-HomeBack p-4 shadow-md rounded-md mt-2"
      >
      <font-awesome-icon icon="phone-flip"  class="text-ColorNerkh"/>
        <p class="text-sm  text-white mx-2"> رزرو رستوران:</p>
        <p class="text-base font-bold  text-white">09011012121 , </p>
        <p class="text-base font-bold  text-white"> 05134324074</p>
      </div>
    </div>
  </Sheet>
</template>

<script>
import { Sheet } from "bottom-sheet-vue3";

export default {
  name: "ContactUsPage",
  components: {
    Sheet,
  },
  data() {
    return {};
  },
};
</script>
